import { render, staticRenderFns } from "./VipSort.vue?vue&type=template&id=d69a676e&scoped=true"
import script from "./VipSort.vue?vue&type=script&lang=js"
export * from "./VipSort.vue?vue&type=script&lang=js"
import style0 from "./VipSort.vue?vue&type=style&index=0&id=d69a676e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69a676e",
  null
  
)

export default component.exports